import React from 'react'
import { Button } from 'react-bulma-components'
import { MissionContractModel } from '../../../../../backend/src/services/resources/period-summaries/period-summary.types'
import { PeriodSummary, PeriodSummaryStatus } from '../../../api/period-summaries'
import Protected from '../../../components/protected/protected'
import { useModal } from '../../../components/modal'
import { useRequestCancellationMutation } from '../../../queries/period-summaries'
import { RequestCancellationModal } from './pre-billing-cancellation-modals'
import { RequestCancellationFormValues } from './pre-billing-cancellation-modals.types'

export interface PreBillingRequestCancellationActionProps {
  /** Current period summary (pre-billing) shown on the details page */
  preBilling: PeriodSummary
}

/**
 * Toolbar-only action: open the "request cancellation" flow for three-parties pre-billings in `active` status.
 * The trigger is rendered next to invoice / export; the modal state lives in this component.
 */
const PreBillingRequestCancellationAction: React.FC<PreBillingRequestCancellationActionProps> = ({
  preBilling,
}) => {
  const requestModal = useModal()

  const requestMutation = useRequestCancellationMutation()

  // Only three-parties contracts use this cancellation workflow
  if (preBilling.contractModel !== MissionContractModel.threeParties) {
    return null
  }

  const status = preBilling.status ?? PeriodSummaryStatus.active

  const handleRequestSubmit = async (values: RequestCancellationFormValues): Promise<void> => {
    await requestMutation.mutateAsync({
      id: preBilling._id,
      requestComment: values.requestComment.trim(),
    })
  }

  if (status !== PeriodSummaryStatus.active) {
    return null
  }

  return (
    <>
      <Protected
        roles={[
          {
            role: 'employerMember',
            action: { resource: 'periodSummaries', name: 'requestCancellation' },
          },
          'interimAgencyMember',
        ]}
      >
        <Button color="light" size="small" mr={2} onClick={() => requestModal.setIsDisplayed(true)}>
          Demander l&apos;annulation de la pré-facturation
        </Button>
      </Protected>

      <RequestCancellationModal actions={requestModal} onSubmit={handleRequestSubmit} />
    </>
  )
}

export default PreBillingRequestCancellationAction
